export default "__VITE_ASSET__DxU9NVbW__"